import { render, staticRenderFns } from "./SalaryEffectTypeCreateOrUpdatePeriod.vue?vue&type=template&id=71d7e908&"
import script from "./SalaryEffectTypeCreateOrUpdatePeriod.vue?vue&type=script&lang=js&"
export * from "./SalaryEffectTypeCreateOrUpdatePeriod.vue?vue&type=script&lang=js&"
import style0 from "./SalaryEffectTypeCreateOrUpdatePeriod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports